import { createSelector } from "reselect";
import { StoreState } from "Store/Reducers";

const fetchModules = ({settings}: StoreState) => settings.modules;
const byEntityId = (_: StoreState, entity_id: any) => entity_id;
const byModule = (_: StoreState, __: any, module: any) => module;
export const getModules = createSelector(fetchModules, ({ids}) => (ids));
export const getModulesById = createSelector(fetchModules, ({entities}) => (entities));
export const getModulesByEntityIdByModule = createSelector(fetchModules, ({byEntityIdByModule}) => (byEntityIdByModule));
export const isModulesFetching = createSelector(fetchModules, ({_isFetching}) => (_isFetching));

export const getModuleByIdByModule = createSelector(
    [
        fetchModules,
        byEntityId,
        byModule
    ],
    ({byEntityIdByModule}, byEntityId, byModule) =>
    byEntityIdByModule?.[byEntityId]?.[byModule]
);